import { useEffect, useRef } from 'react';
import ImageGenSection from './ImageGenSection';
import VideoGenSection from './VideoGenSection';
import VFXSection from './VFXSection';
import ThreeDSection from './ThreeDSection';

const Features = () => {
  const sectionRefs = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            entry.target.classList.remove('animated-out');
          } else {
            entry.target.classList.remove('animated');
            entry.target.classList.add('animated-out');
          }
        });
      },
      { threshold: 0.1, rootMargin: '50px' }
    );

    const refs = sectionRefs.current.filter(Boolean);
    refs.forEach((ref) => observer.observe(ref));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="px-3 sm:px-4 py-12 sm:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 sm:mb-16 text-center px-2">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">Capabilities</h2>
          <p className="mt-3 sm:mt-4 max-w-2xl mx-auto text-sm sm:text-base text-white/60">
            Explore the four pillars of our generation engine. From static pixels to immersive worlds.
          </p>
        </div>

        <div ref={(el) => (sectionRefs.current[0] = el)} className="animate-on-scroll">
          <ImageGenSection />
        </div>
        <div ref={(el) => (sectionRefs.current[1] = el)} className="animate-on-scroll">
          <VideoGenSection />
        </div>
        <div ref={(el) => (sectionRefs.current[2] = el)} className="animate-on-scroll">
          <VFXSection />
        </div>
        <div ref={(el) => (sectionRefs.current[3] = el)} className="animate-on-scroll">
          <ThreeDSection />
        </div>
      </div>
    </section>
  );
};

export default Features;
